import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Box, Card, CardContent, Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const CustomTooltip = ({ active, payload, label }) => {
    const theme = useTheme();
    if (!active || !payload || payload.length === 0) return null;

    const date = new Date(label);
    const formattedDate = `${getOrdinal(date.getDate())} ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
    const sessions = payload.find(p => p.dataKey === "numberOfSims")?.value ?? 0;

    return (
        <Paper
            elevation={4}
            sx={{
                borderRadius: 1,
                padding: theme.customSpacing.md,
                backgroundColor: theme.palette.background.quaternary,
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                color: theme.palette.text.placeholder,
            }}
        >
            <Typography variant="body2" sx={{ color: '#555' }}>
                {formattedDate}: {sessions} Sessions
            </Typography>
        </Paper>
    );
};

const EngagementChart = ({ dataPoints }) => {
    console.log("dataPoints", dataPoints)
    const theme = useTheme();
    return (
        <Box sx={{ height: 300, mt: 2, mb: theme.customSpacing.sm }}>
            <ResponsiveContainer height="100%">
                <LineChart
                    data={dataPoints}
                    margin={{ bottom: 40 }}
                >
                    <CartesianGrid stroke={theme.palette.border.tertiary} vertical={false} />
                    <XAxis
                        dataKey="date"
                        axisLine={false}
                        tickLine={false}
                        tick={{
                            fill: theme.palette.text.tertiary,
                            style: {
                                fontSize: theme.typography.textXS.fontSize
                            },
                            dy: 5,
                        }}
                        label={{
                            value: 'DATE',
                            dy: 30,
                            fill: theme.palette.text.tertiary,
                            fontSize: theme.typography.textXS.fontSize,
                            fontWeight: theme.typography.fontWeightRegular,
                        }}
                        tickFormatter={(date) => {
                            const d = new Date(date);
                            return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
                        }}
                    />
                    <YAxis
                        axisLine={false}
                        tickLine={false}
                        label={{
                            value: 'SESSIONS',
                            angle: -90,
                            position: 'insideLeft',
                            fill: theme.palette.text.tertiary,
                            fontSize: theme.typography.textXS.fontSize,
                            fontWeight: theme.typography.fontWeightRegular,
                            style: { textAnchor: 'middle'},
                        }}
                        tickFormatter={(value) => value.toFixed(0)}
                        allowDecimals={false}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Line
                        type="linear"
                        dataKey="numberOfSims"
                        stroke={theme.palette.foreground.badge_icon}
                        strokeWidth={2}
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default EngagementChart;